import { DoctorService } from '@/services/doctor.service';
import IconLoading from '@/components/icon/IconLoading.vue';
export default {
  components: {
    IconLoading
  },
  props: {
    panelSummary: {
      type: Object,
      default: null
    },
    loadingSummary: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      loadingDoctors: false,
      allDoctors: [],
      selectedDoctorId: null
    };
  },
  computed: {
    doctorOptions() {
      return this.allDoctors.map(d => ({
        value: d.id,
        label: `Dr. ${d.firstname} ${d.lastname}`,
        inactive: d.type === 'inactive'
      }));
    },
    selectedDoctor() {
      if (!this.selectedDoctorId) {
        return null;
      }
      return this.allDoctors.find(d => d.id === this.selectedDoctorId) || null;
    },
    counts() {
      var _this$panelSummary;
      if (!((_this$panelSummary = this.panelSummary) !== null && _this$panelSummary !== void 0 && _this$panelSummary.source)) {
        return {
          total: 0,
          active: 0,
          owned: 0,
          covering: 0,
          licensedStates: 0
        };
      }
      const {
        total,
        active,
        owned,
        covering,
        licensedStates
      } = this.panelSummary.source;
      return {
        total,
        active,
        owned,
        covering,
        licensedStates: (licensedStates || []).length
      };
    }
  },
  async mounted() {
    try {
      this.loadingDoctors = true;
      const {
        data
      } = await DoctorService.getAllDoctorsV2();
      this.allDoctors = Array.isArray(data) ? data : [];
    } catch {
      this.$emit('error', 'Failed to load doctors.');
    } finally {
      this.loadingDoctors = false;
    }
  },
  methods: {
    filterDoctor(option, _label, search) {
      const term = search.trim().toLowerCase();
      return option.label.toLowerCase().includes(term);
    },
    onSelect(doctorId) {
      this.$emit('select', doctorId ? this.selectedDoctor : null);
    },
    formatNumber(n) {
      return Number(n).toLocaleString();
    }
  }
};